import styles from "./MorePageMenu.module.scss";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { ReactComponent as RightArrow } from "@/assets/img/right-arrow.svg";
import { closeTG } from "@/shared/utils";
import { tg } from "@/constants/telegram";
import { useYandexMetrika, GOALS } from "@/hooks/useYandexMetrika";

type MorePageMenuProps = {
  disabled: boolean;
};

export const MorePageMenu: React.FC<MorePageMenuProps> = ({ disabled = true }) => {
  const { trackButtonClick, trackAction } = useYandexMetrika();

  return (
    <ul className={styles.root}>
      <li
        className={classNames(styles.root__item, {
          [styles.root__item_disabled]: disabled,
        })}
        onClick={() => tg.HapticFeedback.impactOccurred("medium")}
      >
        <Link
          to={disabled ? "#" : "/equipments"}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            } else {
              // Отслеживаем нажатие на кнопку "Настроить оборудование"
              trackButtonClick(GOALS.BUTTON_CONFIGURE_EQUIPMENT, { disabled });
            }
          }}
        >
          <span>
            <span className={styles.root__icon}>⚙️</span>
            <span>Настроить оборудование</span>
          </span>
          <RightArrow />
        </Link>
      </li>

      <li
        className={styles.root__item}
        onClick={() => tg.HapticFeedback.impactOccurred("medium")}
      >
        <a
          onClick={() => {
            // Отслеживаем нажатие на кнопку "Написать в поддержку"
            trackButtonClick(GOALS.BUTTON_WRITE_SUPPORT);
            trackAction(GOALS.ACTION_SUPPORT_CONTACTED);
            closeTG();
          }}
          href="https://t.me/FitGuid_bot?start=support-manager"
        >
          <span>
            <span className={styles.root__icon}>👨‍💻</span>
            <span>Написать в поддержку</span>
          </span>
          <RightArrow />
        </a>
      </li>
      <li
        className={styles.root__item}
        onClick={() => tg.HapticFeedback.impactOccurred("medium")}
      >
        <Link
          to="/ai-chat"
          onClick={() => {
            // Отслеживаем нажатие на кнопку "Написать тренеру"
            trackButtonClick(GOALS.BUTTON_WRITE_TRAINER);
            trackAction(GOALS.ACTION_TRAINER_CONTACTED);
          }}
        >
          <span>
            <span className={styles.root__icon}>👋</span>
            <span>Написать тренеру</span>
          </span>
          <RightArrow />
        </Link>
      </li>
    </ul>
  );
};

